export enum EmailCampaignPublishOptionsPanelSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
